import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\Auto-IT\\Apps\\PortalAdmin\\portal-admin3\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\Auto-IT\\Apps\\PortalAdmin\\portal-admin3\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Auto-IT\\Apps\\PortalAdmin\\portal-admin3\\src\\components\\form\\formThemeSwitcher\\FormThemeSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Auto-IT\\Apps\\PortalAdmin\\portal-admin3\\src\\components\\nav\\public\\navbarMenu\\NavbarMenu.tsx");
